import React from 'react';
import { useStore } from '@stores';
import { observer } from 'mobx-react';
import Presentation from './OrderBookmark.presentation';

interface IProps {
  orderId: string;
}

const OrderBookmark: React.FC<IProps> = ({ orderId }) => {
  const { technicalCategoryStore } = useStore();
  const { selectedBookmark } = technicalCategoryStore;

  return <Presentation orderId={orderId} selectedBookmark={selectedBookmark} />;
};

export default observer(OrderBookmark);
